export default __webpack_public_path__ + "static/media/hiking_light.bc79874b.svg";